module.exports = {
      id: "paypal-white-color-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#paypal-white-color",
      toString: function () {
        return this.url;
      }
    }